import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SmartFilterRowViewModel } from './smart-filter-row-view-model';
import { HydratedSmartFilter } from '../../../../models/automation/hydrated-smart-filter';
import { BaseComponent } from '../../../../models/base/base-component';

@Component({
  selector: 'app-smart-filter-card-row',
  templateUrl: './smart-filter-card-row.component.html',
  styleUrls: ['./smart-filter-card-row.component.scss'],
  standalone: false
})
export class SmartFilterCardRowComponent extends BaseComponent {
  @Input() showTopLine: boolean = true;
  @Output() hasSmartFiltersApplied = new EventEmitter<boolean>(true);
  @Output() appliedSmartFiltersChange = new EventEmitter<HydratedSmartFilter[]>(true);

  constructor(
    public viewModel: SmartFilterRowViewModel // provided by logged in scope
  ) {
    super();
  }

  override setupBindings(): void {
    this.viewModel.hasAppliedFilters$.subscribeWhileAlive({
      owner: this,
      next: filters => this.hasSmartFiltersApplied.emit(filters)
    });
    this.viewModel.appliedSmartFilters$.subscribeWhileAlive({
      owner: this,
      next: filters => this.appliedSmartFiltersChange.emit(filters ?? [])
    });
  }

  clearAppliedSmartFilters() {
    this.viewModel.clearAllSmartFilters();
  }

  openSelectSmartFilterModal() {
    this.viewModel.openSelectSmartFilterModal();
  }
}
